module.exports = ['$rootScope', '$http', function ($root, $http) {
    "use strict";

    return {
        create: function (note, plant_id) {
            var url = `/plant/${plant_id}/calendar_note/new/`;
            return $http({
                method: 'POST',
                url: url,
                data: note
            });
        },
        update: function (note, plant_id) {
            var url = `/plant/${plant_id}/calendar_note/${note.id}/`;
            return $http({
                method: 'PATCH',
                url: url,
                data: note
            });
        },
        get: function (note_id, plant_id) {
            var url = `/plant/${plant_id}/calendar_note/${note_id}/`;
            return $http({
                method: 'GET',
                url: url
            });
        },
        delete: function (note_id, plant_id) {
            var url = `/plant/${plant_id}/calendar_note/${note_id}/delete/`;
            return $http({
                method: 'DELETE',
                url: url
            });
        },
        list: function(plant_id, date){

            var url = `/plant/${plant_id}/calendar_notes/`;
            if(angular.isDefined(date.year) && angular.isDefined(date.month) && angular.isDefined(date.day)) {
                url = `/plant/${plant_id}/calendar_notes/${date.year}/${date.month}/${date.day}/`;
            }

            return $http({
                method: 'GET',
                url: url
            });
        }
    };
}];
